/** @module EngineeringChange */

import {featureTogglesStore} from "csi/state/rootStore";

define([
	"csi/locale",
	"csi/xml",
	"lodash"
], function(locale, xml, _) {

	return {

		/**
		 * Show action if not in the list of affected products
		 * @param {Context} ctx
		 * @param {Action} action
		 */
		onAccessActionAddToAffected: function(ctx, action) {
			const product = ctx.getNode() && ctx.getNode().ItemProduct;
			const engineeringChangeNode = ctx.getNodeParent() && ctx.cache.getNode(ctx.getNodeParent().__Parent__);
			const affectedProducts = engineeringChangeNode && engineeringChangeNode.AffectedProducts;
			return !_.includes(affectedProducts, product);
		},

		/**
		 * Disable the tab from being shown if the feature flag "Enable Impact Analysis" is false
		 * @param {Context} ctx
		 * @param {Tab} defTab
		 * @param {string} rootNodeType
		 * @param {Node?} rootNode
		 */
		onAccessTabImpactAnalysis: function(ctx, defTab, rootNodeType, rootNode) {
			return featureTogglesStore.ENABLE_IMPACT_ANALYSIS;
		},

		preActionAffectedItemFetch(ac) {
			const title = locale.resource("FetchAdditionalImpactedItems");
			return this.preActionAffectedItemActions(ac, title);
		},

		preActionAffectedItemUpdate(ac) {
			const title = locale.resource("UpdateImpactedItems");
			return this.preActionAffectedItemActions(ac, title);
		},

		/**
		 * Check if AffectedItem was migrated
		 * @param {Controller} ac
		 * @param {string} dialogTitle
		 */
		preActionAffectedItemActions(ac, dialogTitle) {
			const affectedItem = ac.getNode();
			if (!_.isEmpty(affectedItem.ImpactedItems) && !xml.isValidURL(affectedItem.RootTDSRevisionImpacted)) {
				ac.displayErrorDialog({message:locale.resource("AffectedItemError_MigratedData"), title: dialogTitle});
				return false;
			} else {
				return true;
			}
		},
	};
});
